import { ApiModelVersionDataPoint } from 'src/api/queries';

/**
 * Human-facing version label for a model version: "v3" from the server-side
 * lineage counter (1 = first build, +1 per rebuild). Falls back to the raw
 * Stan solution id (e.g. "1_1_1") only when the backend doesn't serve
 * versionNumber yet (deploy skew).
 */
export const getVersionLabel = (
  model: Pick<ApiModelVersionDataPoint, 'versionNumber' | 'modelID'>,
): string =>
  model.versionNumber !== undefined ? `v${model.versionNumber}` : model.modelID;
